import { Component, ElementRef, HostListener, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import * as Enums from '../../../../../Autofacets-Core/src/app/utils/enums';
import { BrandViewModel } from '../../business-entities/brand-view-model';
import { Filter } from '../../business-entities/Filter';
import { UserRoleMenu } from '../../business-entities/user-role-menu.model';
import { BrandService } from '../../business-services/brand.service';
import { WidgetAppointmentService } from './../../business-services/widget-appointment.service';
import { EditWidgetAppointmentComponent } from './edit-widget-appointment/edit-widget-appointment.component';
import { WidgetAppointmentStatusDropdownModel } from '../../business-entities/widget-appointment-status-dropdown-model';
import { DashboardService } from '../../business-services/dashboard.service';
import { SelectListItemViewModel } from '../../business-entities/select-list-item-view-model';
import { DealerBusinessService } from '../../business-services/dealer.service';
import { DealerViewModel } from '../../business-entities/dealer-view-model';
import { SaveAdvanceSearchFilterModel, SearchArrayModel, DeleteAdvanceSearchFilterModel } from '../../business-entities/save-advance-search-filter';
import { FormControl } from '@angular/forms';
import { AdvanceSearchService } from '../../business-services/advance-search.service';
import { SavedSearchComponent } from '../../components/saved-search/saved-search.component';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { Features } from '../../business-entities/user-role-view-model';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-widget-appointment-request',
  templateUrl: './widget-appointment-request.component.html',
  styleUrls: ['./widget-appointment-request.component.css'],
})
export class WidgetAppointmentRequestComponent implements OnInit {
  searchTerm: string;
  licensePlateClass: string;
  filter: Filter = new Filter();
  filterItems: any[];
  popupCloseResult = false;
  totalCount: number = 0;
  userRoleRightsDetails: UserRoleMenu;
  typeStatusList: any[];
  brandList: BrandViewModel[];
  appointmentList: any[] = [];
  AppointmentStatusList: WidgetAppointmentStatusDropdownModel[];
  SelectedAppointmentStatus:number = 0;
  isAdvanceSearch: boolean = false;
  dealerList: Array<SelectListItemViewModel>;
  dealerId:string;
  myDateRangePickerOptions: Partial<BsDaterangepickerConfig> = Object.assign({},{
    containerClass: 'theme-dark-blue',
    displayMonths:1,
    showWeekNumbers:false,
    rangeInputFormat: 'DD/MM/YYYY',
    customTodayClass: 'custom-today-class'
  });
  bookingDate: any[] = [];
  createdDate: any[] = [];
  saveSearchFilter: SaveAdvanceSearchFilterModel = {
    filterName: null,
    moduleId: Enums.ModuleNames.WidgetAppointment,
    saveSearchArray: []
  };
  control = new FormControl();
  closeResult: string;
  savedSearchListResponse: SaveAdvanceSearchFilterModel[] = [];
  deleteSearchFilter: DeleteAdvanceSearchFilterModel = {
    filterName: null,
    moduleId: Enums.ModuleNames.WidgetAppointment,
  };
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  throttle = 100;
  scrollDistance = 1;
  IsRentalCarActive:boolean;
  features: Features[] = [];

  constructor(
    private globalSetting: GlobalSetting,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private brandService: BrandService,
    private toastr: ToastrService,
    private userService: UserDataService,
    private cookieservice: CookieService,
    private translate: TranslateService,
    private service: WidgetAppointmentService,
    private currentLanguageService: CurrentLanguage,
    private dashboardService: DashboardService,
    private dealerService: DealerBusinessService,
    private advanceSearchService: AdvanceSearchService,
    private _eref: ElementRef,     
    public datePipe: DatePipe,
  ) { }

  ngOnInit(): void {
    this.licensePlateClass = this.globalSetting.getGlobalLicencePlate();
    this.service.widgetAppointmentRequest.startRecordNumber = 0;
    this.service.widgetAppointmentRequest.dealerId = null;
    this.service.widgetAppointmentRequest.statusId = null;
    this.service.widgetAppointmentRequest.typeId = null;
    this.appointmentList = [];
    this.userRoleRightsDetails = (
      this.userService.currentUserValue.userRoleMenuDetails as any[]
    ).find((menu) => menu.moduleId === Enums.ModuleNames.WidgetAppointment);
    this.getBrands().then(() => {
      this.GetAppointmentStatusList();
      this.SelectedAppointmentStatus = (this.dashboardService.WidgetAppointmentStatus == 'Pending')? 1 : this.SelectedAppointmentStatus;
      this.getAppointmentData();
      this.GetDealerList();
    });
    this.currentLanguageService.featureList.subscribe(res => {
      this.features = res;
      if (this.features && this.features.length > 0) {
        this.IsRentalCarActive = this.features.find(x => x.featureCode === Enums.FeatureCode.RenatlCar)?.isActive;
      }
    });
  }

  async GetAppointmentStatusList(){
    await this.service.getAppointmentStatusList().then((response) => {
      this.AppointmentStatusList = response?.result?.result;
      if(this.AppointmentStatusList?.length > 0){
        this.AppointmentStatusList.push({"id":0,"name":"All"});
      }
    })
  }
  @HostListener('document:click', ['$event'])
  onSearchBoxClose(event) {
    if (event) {
      if (!this._eref.nativeElement.getElementsByClassName('advanced-search-box')[0]?.contains(event.target)) {
        this.isAdvanceSearch = false;
      }
    }
  }
  async GetDealerList() {
    await this.dealerService.getDealerBrandList().then(res => {
      if (res) {
        if (res.dealerList) {
          this.dealerList = this.mapdealer(res.dealerList);
          if(this.dealerList?.length===1) 
          {
            this.service.widgetAppointmentRequest.dealerId = res.dealerList[0].dealerId;
          }
        }

      }
    })
  }

  mapdealer(array: DealerViewModel[]) {
    let supperArray = [];
    if (array && array.length > 0) {
      array.forEach(element=>{
        let single = Object();
        single.value = element.dealerId
        single.text = element.dealerName

        supperArray.push(single);
      })
    }
    return supperArray;
  }

  AdvanceSearchSubmit() {    
    let bookingDateFormatted= this.getFormattedDate(this.bookingDate);
    let createdDateFormatted= this.getFormattedDate(this.createdDate);
    this.service.widgetAppointmentRequest.searchTerm = this.searchTerm;
    this.service.widgetAppointmentRequest.startRecordNumber = Constant.startRecordNumber;
    this.service.widgetAppointmentRequest.bookingDate = bookingDateFormatted;
    this.service.widgetAppointmentRequest.createdDate = createdDateFormatted;
    this.appointmentList = [];
    this.getAppointmentData();
    this.isAdvanceSearch = false;
  }
  onReset() {
    this.appointmentList = [];
    this.service.widgetAppointmentRequest.typeId = null;
      this.bookingDate = [];
      this.createdDate = [];
      this.service.widgetAppointmentRequest.createdDate = null;
      this.service.widgetAppointmentRequest.bookingDate = null;
      this.service.widgetAppointmentRequest.dealerId = null;
      this.service.widgetAppointmentRequest.customerName = null;
      this.service.widgetAppointmentRequest.statusId = null;
      this.service.widgetAppointmentRequest.customerNumber = null;
      this.service.widgetAppointmentRequest.licensePlate = null;
      this.getAppointmentData();
  }
  onClose() {
    this.onReset();
    this.isAdvanceSearch = false;
  }

  OpenSaveSearchModal(content) {
    this.saveSearchFilter.saveSearchArray = [];
    this.control = new FormControl();
    this.createSaveSearchModel();
    if (this.saveSearchFilter.saveSearchArray.length > 0) {
      this.modalService.open(content, { size: 'xl', ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }
    else {
      let ErrorMsg = this.translate.instant("lblPleaseFillAtleastOneField");
      this.toastr.error(ErrorMsg);
    }
  }

  createSaveSearchModel() {
    this.saveSearchFilter.filterName = null;
    if (this.service.widgetAppointmentRequest.statusId) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblAppointmentStatus",
        searchValue: this.service.widgetAppointmentRequest.statusId.toString(),
        searchActualValue: this.AppointmentStatusList.find(x => x.id === this.service.widgetAppointmentRequest.statusId)?.name
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.service.widgetAppointmentRequest.typeId) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblType",
        searchValue: this.service.widgetAppointmentRequest.typeId.toString(),
        searchActualValue: this.typeStatusList.find(x => x.id === this.service.widgetAppointmentRequest.typeId)?.name
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.service.widgetAppointmentRequest.licensePlate) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblLicensePlate",
        searchValue: this.service.widgetAppointmentRequest.licensePlate.toString(),
        searchActualValue: this.service.widgetAppointmentRequest.licensePlate
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.service.widgetAppointmentRequest.customerNumber) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblCustomerNo",
        searchValue: this.service.widgetAppointmentRequest.customerNumber.toString(),
        searchActualValue: this.service.widgetAppointmentRequest.customerNumber
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.service.widgetAppointmentRequest.customerName) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblCustomer",
        searchValue: this.service.widgetAppointmentRequest.customerName.toString(),
        searchActualValue: this.service.widgetAppointmentRequest.customerName
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
      let bookingDateFormatted= this.getFormattedDate(this.bookingDate);
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblBookedDateRange",
        searchValue: bookingDateFormatted,
        searchActualValue: bookingDateFormatted
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
      let createdDateFormatted= this.getFormattedDate(this.createdDate);    
      searchModel=
      {
        searchColumnName: "lblCreatedDateRange",
        searchValue: createdDateFormatted,
        searchActualValue: createdDateFormatted
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    if (this.service.widgetAppointmentRequest.dealerId) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblDealer",
        searchValue: this.service.widgetAppointmentRequest.dealerId.toString(),
        searchActualValue: this.dealerList.find(x => x.value === this.service.widgetAppointmentRequest.dealerId)?.text,
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
  }

  SaveAdvanceSearchFilter() {
    if (!this.saveSearchFilter.filterName.replace(/\s/g, "").length) {
      let errorMsg = this.translate.instant("lblSearchNameRequired");
      this.toastr.error(errorMsg);
      return;
    }
    this.advanceSearchService.SaveAdvanceSearchFilter(this.saveSearchFilter).then((response) => {
      if (response.responseCode == Constant.SuccessResponseCode && response.responseObject === true) {
        let successMsg = this.translate.instant("lblSearchFilteredSaved");
        this.toastr.success(successMsg);
        this.modalService.dismissAll();
      }
      else {
        let errorMsg = this.translate.instant("lblSaveSearchFilterNameAlreadyExists");
        this.toastr.error(errorMsg);
      }
    });
  }

  OpenSavedSearchListPopup() {
    this.spinner.show();
    this.GetAdvanceSearchList().then((_res) => {
      const modalRef = this.modalService.open(SavedSearchComponent, {
        size: 'xl',
        ariaLabelledBy: 'modal-basic-title',
      });
      modalRef.componentInstance.isFromAppointment = true;
      modalRef.componentInstance.searchList = this.savedSearchListResponse;
      modalRef.componentInstance.onEditOrRun.subscribe((data) => {
        this.ApplySaveSearch(data);
      });
      modalRef.componentInstance.onDelete.subscribe((data) => {
        this.OnDeleteSaveSearch(data,modalRef);
      });
    });
  }

  async GetAdvanceSearchList() {
    await this.advanceSearchService.GetAdvanceSearchList(Enums.ModuleNames.WidgetAppointment).then(result => {
      if (result) {
        if (result.responseObject.errorCount) {
          this.spinner.hide();
        }
        else {
          this.savedSearchListResponse = result.responseObject;
          this.savedSearchListResponse.forEach(element => {
            element.saveSearchArray.forEach(val => {
              if (val.searchColumnName === 'lblAppointmentStatus') {
                val.searchActualValue = this.AppointmentStatusList.find(x => x.id === +val.searchValue)?.name;
              }
              else if (val.searchColumnName === 'lblType') {
                val.searchActualValue = this.typeStatusList.find(x => x.id === +val.searchValue)?.name;
              }
              else if (val.searchColumnName === 'lblDealer') {
                val.searchActualValue = this.dealerList.find(x => x.value === val.searchValue)?.text;
              }
              else {
                val.searchActualValue = val.searchValue;
              }
            });
          });
        }
      }
      this.spinner.hide();
    },
    _error => {
        this.spinner.hide()
      });
  }

  ApplySaveSearch(data) {
    if (data) {
      let saveSearchDetail = this.savedSearchListResponse.filter(x => x.filterName === data);
      if (saveSearchDetail.length > 0 && saveSearchDetail[0]) {
        saveSearchDetail[0].saveSearchArray.forEach(element => {
          switch (element.searchColumnName) {
            case 'lblAppointmentStatus':
              this.service.widgetAppointmentRequest.statusId = +element.searchValue;
              break;
            case 'lblType':
              this.service.widgetAppointmentRequest.typeId = +element.searchValue;
              break;
            case 'lblLicensePlate':
              this.service.widgetAppointmentRequest.licensePlate = element.searchValue;
              break;
            case 'lblCustomerNo':
              this.service.widgetAppointmentRequest.customerNumber = element.searchValue;
              break;
            case 'lblCustomer':
              this.service.widgetAppointmentRequest.customerName = element.searchValue;
              break;
            case 'lblBookedDateRange':
              let dateValue = element.searchValue.split("-");
              let startDateParts = dateValue[0].trim().split("/");
              let startDate = new Date(+startDateParts[2], +startDateParts[1] - 1, +startDateParts[0]);
              let endDateParts = dateValue[1].trim().split("/");
              let endDate = new Date(+endDateParts[2], +endDateParts[1] - 1, +endDateParts[0]);
              this.bookingDate=[];
              this.bookingDate.push(startDate);
              this.bookingDate.push(endDate);
              break;
            case 'lblCreatedDateRange':
              let createdDateValue = element.searchValue.split("-");
              let createdStartDateParts = createdDateValue[0].trim().split("/");
              let createdStartDate = new Date(+createdStartDateParts[2], +createdStartDateParts[1] - 1, +createdStartDateParts[0]);
              let createdEndDateParts = createdDateValue[1].trim().split("/");
              let createdEndDate = new Date(+createdEndDateParts[2], +createdEndDateParts[1] - 1, +createdEndDateParts[0]);
              this.bookingDate=[];
              this.bookingDate.push(createdStartDate);
              this.bookingDate.push(createdEndDate);
              break;
            case 'lblDealer':
             this.service.widgetAppointmentRequest.dealerId = element.searchValue;
              break;
            default:
              break;
          }
        });
      }
      this.onSearch();
    }
  }

  OnDeleteSaveSearch(searchName,outerModalRef) {
    let modelHeadermsg = this.translate.instant("lblDelete");
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"),this.translate.instant("lblSavedFilters"),true);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => { 
      // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
      if (this.popupCloseResult) {
        this.deleteSearchFilter.filterName = searchName;
        this.advanceSearchService.DeleteAdvanceSearch(this.deleteSearchFilter).then(response => {
          if (response.responseCode == Constant.SuccessResponseCode && response.responseObject === true) {
            this.GetAdvanceSearchList().then(()=>outerModalRef.dismiss());
            let msg = this.translate.instant("lblSaveSearchDeletedSuccessfully");
            this.toastr.success(msg);
          }
          else {
            let msg = this.translate.instant("lblFailedTodeleteSaveSearch");
            this.toastr.error(msg);
          }
        }, error => {
          if (error.status === Constant.BadRequest) {
            let WarningMessage = this.translate.instant("lblErrorWarningForValue")
            this.toastr.warning(WarningMessage);
          }
          else {
            let errorMessage = this.translate.instant("lblErrorMessage");
            this.toastr.error(errorMessage);
          }

        });
      }
    });
  }

  public getBrands(): Promise<void> {
    return new Promise((resolve, _reject) => {
      this.brandService.getBrand().then((res) => {
        if (res) {
          this.brandList = res;
        }
        resolve();
      });
    });
  }

  AppointmentStatusChange(_appointmentStatusId){
    this.service.widgetAppointmentRequest.startRecordNumber = 0;
    this.appointmentList = [];
    this.getAppointmentData();
  }

  onScrollDown(_ev) {
    if(this.totalCount > this.appointmentList.length){
      this.service.widgetAppointmentRequest.startRecordNumber = this.appointmentList.length;
      this.getAppointmentData();
    }
  }

  async getAppointmentData() {
    let language = this.cookieservice.get('userSelectedLanguage');
    this.service.widgetAppointmentRequest.languageCode = language;
    this.service.widgetAppointmentRequest.appointmentStatusId = this.SelectedAppointmentStatus;
    this.spinner.show();
    await this.service.getWidgetAppointmentList(this.service.widgetAppointmentRequest).then((response) => {
        this.spinner.hide();
        this.appointmentList.push(...this.AppointmentDataMapper(
          response.responseObject.widgetAppoitmentList,
          response.responseObject.widgetAppointmentTypeList
        ));
        this.typeStatusList = response.responseObject.widgetAppointmentTypeList;
        if (response.responseObject?.result?.errorCode == '1075') {
          this.totalCount = 0;
        }
        else {
          this.totalCount =response.responseObject.widgetAppoitmentList.length===0? 0 : response.responseObject.widgetAppoitmentList[0].totalRecords;
        }
      },_error => {
        this.spinner.hide();
      });
  }

  private AppointmentDataMapper(List: any, TypeStatusList: any) {
    let supperArray = [];
    if (List && List.length > 0) {
      for (let index = 0; index < List.length; index++) {
        const element = List[index];
        let single = Object();
        single.rowNumber =
          this.service.widgetAppointmentRequest.startRecordNumber + 1 + index;
        single.id = element.id;
        single.licensePlate = element.licensePlate;
        single.existingVehicleId = element.existingVehicleId;
        single.existingCustomerId = element.existingCustomerId;
        single.customerName = element.customerName;
        single.email = element.email;
        single.mobileNo = element.mobileNo;
        if(element.mobileCode != null && element.mobileCode[0]=="+")
          single.mobileCode = element.mobileCode;
        else
        single.mobileCode ="+"+ element.mobileCode;
        single.dealerName = element.dealerName;
        single.brand = element.brandCode ? this.getBrandImage(element.brandCode) : null;
        single.dealerId = element.dealerId;
        single.model = element.model;
        single.brandCode = element.brandCode;
        single.brandName = element.brandName;
        single.bookedDate = element.bookedDate;
        single.bookedDateTime = element.bookedDateTime ? new Date(element.bookedDateTime + 'Z') : null;
        single.createdDate = element.createdDate;
        single.createdDateTime = element.createdDateTime ? new Date(element.createdDateTime + 'Z') : null;
        single.typeId = element.typeId;
        single.typeName = element.typeId ? this.getTypeName(element.typeId, TypeStatusList) : null;
        single.typeColor = element.typeId ? this.getTypeColor(element.typeId, TypeStatusList) : null;
        single.statusId = element.statusId;
        single.statusName = element.statusName;
        single.isRentalCarRequire = element.isRentalCarRequire;
        single.widgetAppointmentNo = element.widgetAppointmentNo;
        supperArray.push(single);
      }
    }
    return supperArray;
  }

  getBrandImage(key: any) {
    if (this.brandList && this.brandList.length > 0) {
      return this.brandList.filter(
        (x) => x.brandCode.toUpperCase() === key.toUpperCase()
      )[0]?.image;
    }
  }

  async onSort({ column, direction }: SortEvent) {
    // resetting other headers
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.service.widgetAppointmentRequest.sortColumn = column;
    this.service.widgetAppointmentRequest.sortDirection = direction;
    this.service.widgetAppointmentRequest.startRecordNumber = 0;
    this.appointmentList = [];
    await this.getAppointmentData();
  }

  getTypeColor(typeId: any, typeStatusList: any) {
    let color = typeStatusList.filter((item) => item.id === typeId);
    return color[0]?.colorCode;
  }

  getTypeName(typeId: any, typeStatusList: any) {
    let typeName = typeStatusList.filter((item) => item.id === typeId);
    return typeName[0]?.name;
  }

  onSearchFilter() {
    this.service.widgetAppointmentRequest.searchTerm = this.searchTerm;
    this.service.widgetAppointmentRequest.startRecordNumber = 0;
    this.appointmentList = [];
    this.getAppointmentData();
  }

  onEdit(appointment) {
    this.service.widgetAppointment = appointment;
    const modalref = this.modalService.open(EditWidgetAppointmentComponent, {
      size: 'lg',
      windowClass: 'EditPopup',
    });
    modalref.result.then(
      (response) => {
        if (response.success) {
          this.ngOnInit();
        }
      }
    );
  }

  onSearch() {
    this.isAdvanceSearch = true;
  }

  onRefresh() {
   return this.onSearchFilter();
  }

  DeleteAppointment(appointment: any) {
    let modelHeadermsg = this.translate.instant('lblDelete');
    let modelBodymsg = Utility.createMessage(
      this.translate.instant('lblSureToDelete'),
      this.translate.instant('lblAppointment'),
      true
    );
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then(
      (_result) => {
        // This is intentional
      },
      (reason) => {
        this.popupCloseResult = this.getDismissReason(reason);
        if (this.popupCloseResult) {
          this.service.DeleteAppointment(appointment.id).then((response) => {
            if (response.responseCode == Constant.SuccessResponseCode) {
              let successMsg = this.translate.instant('lblAppointmentDeleted');
              this.toastr.success(successMsg);
              this.onRefresh();
            } else {
              let errorMsg = this.translate.instant('lblAppointmentNotDeleted');
              this.toastr.error(errorMsg);
            }
          });
        }
      }
    );
  }

  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }

  getFormattedDate(dateRangeArray: any[]){
    let formattedDate: string= "";
    if(dateRangeArray.length != 0){
      let beginDate= this.datePipe.transform(dateRangeArray[0], 'dd/MM/yyyy');
      let lastDate= this.datePipe.transform(dateRangeArray[1], 'dd/MM/yyyy');
      formattedDate= beginDate + ' - ' + lastDate;
    }
    return formattedDate;
  }
}
